import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

//pass props called "tabLabels" array containing the tab label strings
//pass props called "tabElements" array containg the tab element components 

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`research-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      >
      {value === index && (
        <Box sx={{ paddingTop: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const a11yProps = (index) => {
  return {
    id: `research-tab-${index}`,
    "aria-controls": `research-tabpanel-${index}`,
  };
};

const CustomTab = ({tabElements, tabLabels}) => {
  const [activeTabValue, setActiveTabValue] = React.useState(0);
  
  const handleTabChange = (event, newValue) => {
    setActiveTabValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={activeTabValue}
          onChange={handleTabChange}
          aria-label="research tabs"
        >
          {tabLabels.map((tabLabel, index) => {
            return <Tab key={index} label={tabLabel} {...a11yProps(index)} />;
          })}
        </Tabs>
      </Box>
      {tabElements.map((tabElement, index) => {
        return (
          <TabPanel key={index} value={activeTabValue} index={index}>
            {tabElement}
          </TabPanel>
        );
      })}
    </Box>
  );
};

export default CustomTab;
